import React from 'react'
import injectStyles from 'react-jss'

import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { SearchInput } from 'Components/Header/SearchInput'
import { styles } from './style'

import SimpleTableTable from 'Components/SimpleTableTable'
import Pagination from '../../../../../Components/FilterAndPaginationComponent/Pagination'
import { isDefined } from '../../../../../shared/libraries/utils/object'
import {
  MISSION_STATUS_ENUM,
  MISSION_STATUS_SPIED,
  MISSION_STATUS_SPYING,
  TIME_AFTERNOON,
  TIME_LUNCH,
  TIME_MORNING,
} from '../../../../../shared/constants'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'

const COMBINED_MISSION_STATUSES = [
  { label: 'All', value: null },
  { label: 'Available', value: MISSION_STATUS_ENUM.AVAILABLE },
  { label: 'Booked', value: MISSION_STATUS_ENUM.BOOKED },
  { label: 'Spying', value: MISSION_STATUS_SPYING },
  { label: 'Spied', value: MISSION_STATUS_SPIED },
]

const DAY_STATUS_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Morning', value: TIME_MORNING },
  { label: 'Lunch', value: TIME_LUNCH },
  { label: 'Afternoon', value: TIME_AFTERNOON },
]

const View = props => {
  const {
    data,
    handleSearch,
    changeSort,
    setFilters,
    isLoading,
    search,
    filters,
    orderBy,
    onOffsetChange,
    resultsPerPage,
    totalCount,
    offsetRecordsStart,
    classes,
    history,
  } = props

  const action = node => {
    history.push(`/dashboard/mission/${node.missionId}`)
  }

  if (isLoading) {
    return <LoadingIndicator />
  }

  return (
    <div>
      <FiltersWrapper className={classes.filterSearchWrapper}>
        <FilterBox>
          <SearchInput
            placeholder="Search anything"
            searchHandler={handleSearch}
            value={search}
          />
        </FilterBox>

        <div className={classes.filterWrapper}>
          <FilterBox>
            <FilterSelect
              hasPrimaryText={false}
              label="Day Period"
              onChange={(element, index, value) =>
                setFilters({ ...filters, 'dayPeriod': value })
              }
              options={DAY_STATUS_OPTIONS}
              value={filters.dayPeriod}
              sorted={!!filters.dayPeriod}
            />
          </FilterBox>
          <FilterBox>
            <FilterSelect
              hasPrimaryText={false}
              label="Status"
              onChange={(element, index, value) =>
                setFilters({ ...filters, 'status': value })
              }
              options={COMBINED_MISSION_STATUSES}
              value={filters.status}
              sorted={!!filters.status}
            />
          </FilterBox>
        </div>
      </FiltersWrapper>

      <div className={props.classes.wrapperTable}>
        <SimpleTableTable
          data={data}
          header={[
            'Client',
            'Week',
            'Date',
            'Time',
            'TOD',
            'Location',
            'BA',
            'Spy Name',
            'Checkin',
            'Checkout',
            'Status',
            'Rating',
          ]}
          sortOn={[
            'Week',
            'Date',
            'Time',
            'TOD',
            'Location',
            'BA',
            'Checkin',
            'Checkout',
            'Rating',
          ]}
          showPages={false}
          action={action}
          onTableDataUpdate={data => {
            changeSort(data.sortBy)
          }}
          orderBy={orderBy}
          loadingData={isLoading}
        />
      </div>
      <Pagination
        className={classes.pagination}
        total={isDefined(totalCount) ? totalCount : data.length}
        offset={isDefined(offsetRecordsStart) ? offsetRecordsStart : 0}
        resultsPerPage={
          isDefined(resultsPerPage) ? resultsPerPage : data.length
        }
        onOffsetChange={onOffsetChange}
      />
    </div>
  )
}

export default injectStyles(styles)(View)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spy/Roster/View.js